import { ApplicationName } from '@mediacoach/ui'

export const APPLICATION_MAP = {
  SportianAnalysis: ApplicationName.Analysis,
  Wimu: ApplicationName.HudlSignal,
  Footovision: ApplicationName.Coachvision,
}
